import React from 'react'
import { StyledTabPanel } from './styles'

export type TabPanelProps = {
  value: number
  index: number
  minHeight?: string
  panelMargins?: number[]
  border?: boolean
  borderColor?: string
}

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (props) => {
  const { children, value, index, minHeight, panelMargins, border, borderColor, ...other } = props

  return (
    <StyledTabPanel
      value={value}
      index={index}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      minHeight={minHeight}
      panelMargins={panelMargins}
      border={border}
      borderColor={borderColor}
      {...other}
    >
      {value === index && <>{children}</>}
    </StyledTabPanel>
  )
}
